
import Vue from "vue";
import API from "../service/config";
import { post, fetch, patch, put, toDelete } from "../service/http-service";
import { Loading } from "element-ui";
import axios from 'axios';
import Echart2 from "@/components/Echart2.vue";
export default Vue.extend({
  name: "Browse",
  components: {
    Echart2,
  },
  props: {
    params: {
      type: Object,
      default: function () {
        return {
          cellType: [],
        };
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isavg: false,
      IsSeachMark: false,
      isShowTable: true,
      isFuzzy: true,
      geneData: [{}],
      gene: [],
      exploreData: {} as any,
      explore: [],
      keyValue: "",
      avgValue: [0, 6],
      logValue: [-1, 3],
      avgValFormat: 100,
      logValFormat: 1,
      avgLimited: 25,
      avgMarks: {
        0: {
          style: {
            color: "#fff",
          },
          label: this.$createElement("strong", "0"),
        },
        0.25: {
          style: {
            color: "#fff",
          },
          label: this.$createElement("strong", "0.25"),
        },
        1: {
          style: {
            color: "#fff",
          },
          label: this.$createElement("strong", "1"),
        },
        3: {
          style: {
            color: "#fff",
          },
          label: this.$createElement("strong", "3"),
        },
      },
      ppoverValue: false,
      ppoverValue2: false,
      ppoverValue3: false,
      ppoverValueAll: false,
      keywordbycelltype: "",
      keywordbydisease: "",
      isexplore: false,
      filterText: "",
      cellCheck: true,
      cellStrictly: false,
      cellStrictly2: false,
      zNodes: [],
      zNodes2: [],
      nodes: {},
      nodes2: {},
      tableColumns: [
        { prop: "CodeSystem", label: "Code System" },
        { prop: "GeneCode", label: "Gene Code" },
        { prop: "Chromosome", label: "Chromosome" },
        { prop: "Symbol", label: "Symbol" },
        { prop: "Description", label: "Description" },
        { prop: "TypeofGene", label: "Type of Gene" },
      ],
      menuData: [
        {
          name: "Transcriptome",
          isActive: true,
          childrens: [
            {
              name: "single-cell RNA-seq",
              value: "singleCellRNASeq",
              isActive: true,
              data: {
                title: "single-cell RNA-seq",
                desc: "singleCellRNASeqDesc",
                diseases: 6,
                samples: 154,
                publications: 17,
                cellNumbers: 872591,
                cellTypes: 40,
                tissueTypes: 0,
                differentiallyExpressedGenes: 0,
              },
              tableData: [
                {
                  name: "projectId",
                  label: "projectID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "datasetId",
                  label: "datasetID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "pval",
                  label: "pval",
                  isFilter: false,
                  isSort: true,
                  width: 120,
                },
                {
                  name: "avgLog2Fc",
                  label: "avgLog2Fc",
                  isFilter: false,
                  isSort: true,
                  width: 130,
                },
                {
                  name: "pct1",
                  label: "pct1",
                  isFilter: false,
                  isSort: true,
                  width: 80,
                },
                {
                  name: "pct2",
                  label: "pct2",
                  isFilter: false,
                  isSort: true,
                  width: 80,
                },
                {
                  name: "pvalAdj",
                  label: "pvalAdj",
                  isFilter: false,
                  isSort: true,
                  width: 120,
                },
                {
                  name: "cellType",
                  label: "cellType",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "gene",
                  label: "gene",
                  isFilter: false,
                  isSort: false,
                  width: 100,
                },
                {
                  name: "tissue",
                  label: "tissue",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "species",
                  label: "species",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "disease",
                  label: "disease",
                  isFilter: true,
                  isSort: false,
                  width: 200,
                },
                {
                  name: "libraryPreparationProtocol",
                  label: "libraryPreparationProtocol",
                  isFilter: true,
                  isSort: false,
                  width: 250,
                },
              ],
            },
            {
              name: "RNA-seq",
              value: "rnaseq",
              isActive: false,
              data: {
                title: "RNA-seq",
                desc: "RNASeqDesc",
                diseases: 8,
                samples: 1477,
                publications: 7,
                cellNumbers: 0,
                cellTypes: 0,
                tissueTypes: 0,
                differentiallyExpressedGenes: 60443,
              },
              tableData: [
                {
                  name: "projectId",
                  label: "projectID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "datasetId",
                  label: "datasetID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "pvalue",
                  label: "pvalue",
                  isFilter: false,
                  isSort: true,
                  width: 80,
                },
                {
                  name: "padj",
                  label: "padj",
                  isFilter: false,
                  isSort: true,
                  width: 80,
                },
                {
                  name: "log2FoldChange",
                  label: "log2FoldChange",
                  isFilter: false,
                  isSort: true,
                  width: 130,
                },
                {
                  name: "treatment",
                  label: "treatment",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "gene",
                  label: "gene",
                  isFilter: false,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "fc",
                  label: "fc",
                  isFilter: false,
                  isSort: true,
                  width: 80,
                },
                {
                  name: "minusLog10Pvalue",
                  label: "minusLog10Pvalue",
                  isFilter: false,
                  isSort: true,
                  width: 80,
                },
                {
                  name: "species",
                  label: "species",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "disease",
                  label: "disease",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "tissue",
                  label: "tissue",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "libraryPreparationProtocol",
                  label: "libraryPreparationProtocol",
                  isFilter: true,
                  isSort: false,
                  width: 250,
                },
              ],
            },
          ],
        },
        {
          name: "Epigenome",
          isActive: true,
          childrens: [
            {
              name: "single-cell ATAC-seq",
              value: "singleCellATACSeq",
              isActive: false,
              data: {
                title: "single-cell ATAC-seq",
                desc: "singleCellATACSeqDesc",
                diseases: 1,
                samples: 6,
                publications: 2,
                cellNumbers: 19360,
                cellTypes: 45,
                tissueTypes: 0,
                differentiallyExpressedGenes: 0,
              },
              tableData: [
                {
                  name: "projectId",
                  label: "projectID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "datasetId",
                  label: "datasetID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "pval",
                  label: "pval",
                  isFilter: false,
                  isSort: true,
                  width: 120,
                },
                {
                  name: "avgLog2Fc",
                  label: "avgLog2Fc",
                  isFilter: false,
                  isSort: true,
                  width: 130,
                },
                {
                  name: "pct1",
                  label: "pct1",
                  isFilter: false,
                  isSort: true,
                  width: 80,
                },
                {
                  name: "pct2",
                  label: "pct2",
                  isFilter: false,
                  isSort: true,
                  width: 80,
                },
                {
                  name: "pvalAdj",
                  label: "pvalAdj",
                  isFilter: false,
                  isSort: true,
                  width: 120,
                },
                {
                  name: "gene",
                  label: "gene",
                  isFilter: false,
                  isSort: false,
                  width: 100,
                },
                {
                  name: "species",
                  label: "species",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "tissue",
                  label: "tissue",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "disease",
                  label: "disease",
                  isFilter: true,
                  isSort: false,
                  width: 200,
                },
                {
                  name: "libraryPreparationProtocol",
                  label: "libraryPreparationProtocol",
                  isFilter: true,
                  isSort: false,
                  width: 250,
                },
              ],
            },
            {
              name: "ATAC-seq",
              value: "atacseq",
              isActive: false,
              data: {
                title: "ATAC-seq",
                desc: "ATACSeqDesc",
                diseases: 1,
                samples: 1,
                publications: 1,
                cellNumbers: 0,
                cellTypes: 0,
                tissueTypes: 4,
                differentiallyExpressedGenes: 0,
              },
              tableData: [
                {
                  name: "projectId",
                  label: "projectID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "datasetId",
                  label: "datasetID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "pvalue",
                  label: "pvalue",
                  isFilter: false,
                  isSort: true,
                  width: 120,
                },
                {
                  name: "qvalue",
                  label: "qvalue",
                  isFilter: false,
                  isSort: true,
                  width: 120,
                },
                {
                  name: "annotation",
                  label: "annotation",
                  isFilter: true,
                  isSort: false,
                  width: 130,
                },
                {
                  name: "geneId",
                  label: "geneID",
                  isFilter: false,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "gene",
                  label: "gene",
                  isFilter: false,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "chrom",
                  label: "chrom",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "chromStart",
                  label: "chromStart",
                  isFilter: false,
                  isSort: true,
                  width: 120,
                },
                {
                  name: "width",
                  label: "width",
                  isFilter: false,
                  isSort: true,
                  width: 80,
                },
                {
                  name: "strand",
                  label: "strand",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "name",
                  label: "name",
                  isFilter: false,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "signalValue",
                  label: "signalValue",
                  isFilter: false,
                  isSort: true,
                  width: 120,
                },
                {
                  name: "species",
                  label: "species",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "tissue",
                  label: "tissue",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "disease",
                  label: "disease",
                  isFilter: true,
                  isSort: false,
                  width: 200,
                },
                {
                  name: "libraryPreparationProtocol",
                  label: "libraryPreparationProtocol",
                  isFilter: true,
                  isSort: false,
                  width: 250,
                },
                {
                  name: "transcriptId",
                  label: "transcriptID",
                  isFilter: false,
                  isSort: false,
                  width: 150,
                },
                {
                  name: "distanceToTss",
                  label: "distanceToTss",
                  isFilter: false,
                  isSort: true,
                  width: 150,
                },
              ],
            },
          ],
        },
        {
          name: "Immunome",
          isActive: true,
          childrens: [
            {
              name: "single-cell TCR-seq",
              value: "singleCellTCRSeq",
              isActive: false,
              data: {
                title: "single-cell TCR-seq",
                desc: "singleCellTCRSeqDesc",
                diseases: 2,
                samples: 84,
                publications: 4,
                cellNumbers: 86361,
                cellTypes: 0,
                tissueTypes: 0,
                differentiallyExpressedGenes: 0,
              },
              tableData: [
                {
                  name: "projectId",
                  label: "projectID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "datasetId",
                  label: "datasetID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "cellType",
                  label: "cellType",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "ctStrict",
                  label: "ctStrict",
                  isFilter: false,
                  isSort: false,
                  width: 300,
                },
                {
                  name: "cellNumber",
                  label: "cellNumber",
                  isFilter: false,
                  isSort: true,
                  width: 130,
                },
                {
                  name: "ctGene",
                  label: "ctGene",
                  isFilter: false,
                  isSort: false,
                  width: 200,
                },
                {
                  name: "ctAa",
                  label: "ctAa",
                  isFilter: false,
                  isSort: false,
                  width: 200,
                },
                {
                  name: "ctNt",
                  label: "ctNt",
                  isFilter: false,
                  isSort: false,
                  width: 250,
                },
                {
                  name: "species",
                  label: "species",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "disease",
                  label: "disease",
                  isFilter: true,
                  isSort: false,
                  width: 200,
                },
                {
                  name: "libraryPreparationProtocol",
                  label: "libraryPreparationProtocol",
                  isFilter: true,
                  isSort: false,
                  width: 250,
                },
              ],
            },
            {
              name: "TCR-seq",
              value: "tcrseq",
              isActive: false,
              data: {
                title: "TCR-seq",
                desc: "TCRSeqDesc",
                diseases: 9,
                samples: 1233,
                publications: 11,
                cellNumbers: 0,
                cellTypes: 0,
                tissueTypes: 6,
                differentiallyExpressedGenes: 0,
              },
              tableData: [
                {
                  name: "projectId",
                  label: "projectID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "datasetId",
                  label: "datasetID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "sampleName",
                  label: "sampleName",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "aminoAcid",
                  label: "aminoAcID",
                  isFilter: false,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "vresolved",
                  label: "vresolved",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "dresolved",
                  label: "dresolved",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "jresolved",
                  label: "jresolved",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "templates",
                  label: "templates",
                  isFilter: false,
                  isSort: true,
                  width: 120,
                },
                {
                  name: "productiveFrequency",
                  label: "productiveFrequency",
                  isFilter: false,
                  isSort: true,
                  width: 200,
                },
                {
                  name: "species",
                  label: "species",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "tissue",
                  label: "tissue",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "disease",
                  label: "disease",
                  isFilter: true,
                  isSort: false,
                  width: 200,
                },
                {
                  name: "libraryPreparationProtocol",
                  label: "libraryPreparationProtocol",
                  isFilter: true,
                  isSort: false,
                  width: 250,
                },
              ],
            },
          ],
        },
        {
          name: "Genome",
          isActive: true,
          childrens: [
            {
              name: "GWAS",
              value: "singleCellWGS",
              isActive: false,
              data: {
                title: "GWAS",
                desc: "GWASDesc",
                traits: 86,
                mesh: 28,
                SNP: 71755,
                gene: 3340,
                cellTypes: 0,
                tissueTypes: 0,
                differentiallyExpressedGenes: 0,
              },
              tableData: [
                {
                  name: "projectId",
                  label: "projectID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "datasetId",
                  label: "datasetID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "gene",
                  label: "gene",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "trait",
                  label: "trait",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "meshTerm",
                  label: "meshTerm",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "rsID",
                  label: "rsID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                // {
                //   name: "FINEMAP",
                //   isFilter: true,
                //   isSort: false,
                //   width: 120,
                // },
                // {
                //   name: "Chromsome",
                //   isFilter: true,
                //   isSort: false,
                //   width: 120,
                // },
                {
                  name: "position",
                  label: "position",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "annotation",
                  label: "annotation",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "geneId",
                  label: "geneID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "species",
                  label: "species",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
              ],
            },
          ],
        },
        {
          name: "SpatialTranscriptome",
          isActive: true,
          childrens: [
            {
              name: "spatial transcriptomics",
              value: "spatialTranscriptomics",
              isActive: false,
              data: {
                title: "spatial transcriptomics",
                desc: "spatialTranscripomics",
                diseases: 3,
                samples: 10,
                publications: 2,
                cellNumbers: 11969,
                cellTypes: 0,
                tissueTypes: 6,
                differentiallyExpressedGenes: 0,
              },
              tableData: [
                {
                  name: "projectId",
                  label: "projectID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "datasetId",
                  label: "datasetID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                // {
                //   name: "pVal",
                //   isFilter: true,
                //   isSort: false,
                //   width: 120,
                // },
                {
                  name: "avgLog2Fc",
                  label: "avgLog2Fc",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "pct1",
                  label: "pct1",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "pct2",
                  label: "pct2",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                // {
                //   name: "pValAdj",
                //   isFilter: true,
                //   isSort: false,
                //   width: 120,
                // },
                {
                  name: "cluster",
                  label: "cluster",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "gene",
                  label: "gene",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "tissue",
                  label: "tissue",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "species",
                  label: "species",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "disease",
                  label: "disease",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "libraryPreparationProtocol",
                  label: "libraryPreparationProtocol",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
              ],
            },
          ],
        },
        {
          name: "Multimodal",
          isActive: true,
          childrens: [
            {
              name: "CITE-seq",
              value: "citeseq",
              isActive: false,
              data: {
                title: "CITE-seq",
                desc: "CITESeqDesc",
                diseases: 1,
                samples: 136,
                publications: 2,
                cellNumbers: 681730,
                cellTypes: 20,
                tissueTypes: 0,
                differentiallyExpressedGenes: 0,
              },
              tableData: [
                {
                  name: "projectId",
                  label: "projectID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "datasetId",
                  label: "datasetID",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "pval",
                  label: "pval",
                  isFilter: false,
                  isSort: true,
                  width: 130,
                },
                {
                  name: "avgLog2Fc",
                  label: "avgLog2Fc",
                  isFilter: false,
                  isSort: true,
                  width: 130,
                },
                {
                  name: "pct1",
                  label: "pct1",
                  isFilter: false,
                  isSort: true,
                  width: 80,
                },
                {
                  name: "pct2",
                  label: "pct2",
                  isFilter: false,
                  isSort: true,
                  width: 80,
                },
                {
                  name: "pvalAdj",
                  label: "pvalAdj",
                  isFilter: false,
                  isSort: true,
                  width: 120,
                },
                {
                  name: "cluster",
                  label: "cluster",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "gene",
                  label: "gene",
                  isFilter: false,
                  isSort: false,
                  width: 100,
                },
                {
                  name: "tissue",
                  label: "tissue",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "species",
                  label: "species",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
                {
                  name: "disease",
                  label: "disease",
                  isFilter: true,
                  isSort: false,
                  width: 200,
                },
                {
                  name: "libraryPreparationProtocol",
                  label: "libraryPreparationProtocol",
                  isFilter: true,
                  isSort: false,
                  width: 250,
                },
                {
                  name: "features",
                  label: "features",
                  isFilter: true,
                  isSort: false,
                  width: 120,
                },
              ],
            },
          ],
        },
      ],
      tableType: "single-cell RNA-seq",
      tableThData: [],
      keyword: "",
      keywordV: "",
      tableData: [],
      loading: false,
      loadingTable: false,
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      type: "id",
      isasc: true,
      showTable: false,
      tableMap: {} as any,
      //filter
      datasetId: [] as any,
      datasetIdValue: [],

      filterField: null,
      metadataFilterVo: {},

      visitTable: true,
      ipAddress: null,
      localIP: null,
      infoData: {} as any,
    };
  },
  watch: {
    isexplore(val) {
      if (!val) {
        this.ppoverValue = false;
        this.ppoverValue2 = false;
        this.ppoverValue3 = false;
      }
    },
    keyword(){
      if(this.showTable){
        this.visitTableFun();
      }
    },
    keywordbycelltype(val) {
      if (val) {
        console.log("val:" + val);
        (this.$refs.tree as any).filter(val);
      }
    },
    keywordbydisease(val) {
      if (val) {
        (this.$refs.tree2 as any).filter(val);
      }
    },
  },
  async created() {
    if (this.$route.query.search) {
      let searchStr: any = this.$route.query.search;
      this.keyword = searchStr;
      this.visitTable = true;
    }
    if (this.$route.query.menu) {
      let value: any = this.$route.query.menu;
      this.tableType = value;
    }
    const nodes = await this.celltypeChange();
    this.zNodes = nodes;

    this.setCellDisabled(this.zNodes[0]);

    const nodes2 = await this.diseaseChange();
    this.zNodes2 = nodes2;

    this.setCellDisabled2(this.zNodes2[0]);
  },
  mounted() {
    window.addEventListener("click", this.handleOutsideClick);

    (this.$refs.tableContainer as HTMLElement).addEventListener(
      "scroll",
      this.handleScroll
    );
    let data: any = this.menuData[0].childrens[0].tableData;
    this.tableThData = data;
    let data2: any = this.menuData[0].childrens[0].data;
    this.infoData = data2;
    let url = window.location.href;
    let regex = /menu=([^&]+)/;
    let match = url.match(regex);
    if (match) {
      let menu = match[1].replace(/%20/g, " ");
      for (let i = 0; i < this.menuData.length; i++) {
        for (let j = 0; j < this.menuData[i].childrens.length; j++) {
          if (menu === this.menuData[i].childrens[j].name) {
            let data: any = this.menuData[i].childrens[j].tableData;
            this.tableThData = data;
            let data2: any = this.menuData[i].childrens[j].data;
            this.infoData = data2;
          }
        }
      }
    }
    this.getType();
    this.getDataList().then(this.getDataList2);
  },
  beforeDestroy() {
    window.removeEventListener("click", this.handleOutsideClick);
    (this.$refs.tableContainer as HTMLElement).removeEventListener(
      "scroll",
      this.handleScroll
    );
  },
  computed: {
    // exploreDataR(){
    //   console.log(this.exploreData)
    //   return this.exploreData;
    // }
  },
  methods: {
    Restart() {
      (this.$refs.tree as Vue & { setCheckedKeys: Function }).setCheckedKeys(
        []
      );
      this.keyword = "";
      this.explore = [];
      this.getDataList().then(this.getDataList2);
    },
    formatTooltip(val: any) {
      return val / this.avgValFormat;
    },
    formatTooltip2(val: any) {
      return val / this.logValFormat;
    },
    checkPopover(item: any) {
      return this.ppoverValue3 && item.length !== 0;
    },
    async celltypeChange() {
      const node = await this.$store.dispatch("cellCollection/fetchCelltree");
      return node;
    },
    async diseaseChange() {
      const node = await this.$store.dispatch(
        "diseaseCollection/fetchCelltree"
      );
      return node;
    },
    setCellDisabled(node: any, parentNode: any = null): void {
      if (node.type === 0 && node.label !== "Cell") {
        const children = parentNode ? parentNode.children : [];
        if (parentNode) {
          parentNode.children = children.filter((d: any) => d.id !== node.id);
        }
      }
      if (node.children) {
        node.children.forEach((item: any) => {
          this.setCellDisabled(item, node);
        });
      }
    },
    setCellDisabled2(node: any, parentNode: any = null): void {
      if (node.type === 0 && node.label !== "Respiratory system disease") {
        const children = parentNode ? parentNode.children : [];
        if (parentNode) {
          parentNode.children = children.filter((d: any) => d.id !== node.id);
        }
      }
      if (node.children) {
        node.children.forEach((item: any) => {
          this.setCellDisabled(item, node);
        });
      }
    },
    getType() {
      fetch(API.domainUrl + API.getType).then((response: any) => {
        if (response.status.code == 200) {
          const expFilter = {
            diseases: [],
            cellType: [],
            tissueType: [],
          };

          expFilter.tissueType = response.data.tissueType;
          this.exploreData = expFilter;
        } else {
          this.$message.error(response.status.msg);
        }
      });
    },
    searchData(key: any, otherkey: any) {
      this.keyValue = key;
      this.pageIndex = 1;
      this.pageSize = 10;
      this.type = otherkey;
      this.getDataList().then(this.getDataList2);
      this.ppoverValue = false;
      this.ppoverValue2 = false;
      this.isexplore = false;
    },
    showPopover(key: any, item: any) {
      if (key == "cellType") {
        this.ppoverValue = !this.ppoverValue;
        this.ppoverValue2 = false;
        this.ppoverValue3 = false;
      }
      if (key == "diseases") {
        this.ppoverValue2 = !this.ppoverValue2;
        this.ppoverValue = false;
        this.ppoverValue3 = false;
      }
      if (key == "tissueType") {
        this.ppoverValue3 = !this.ppoverValue3;
        this.ppoverValue = false;
        this.ppoverValue2 = false;
      }
    },
    handleClick(event: MouseEvent) {
      event.stopPropagation();
    },
    handleOutsideClick(event: MouseEvent) {
      this.isexplore = false;
      this.ppoverValue = false;
      this.ppoverValue2 = false;
      if (
        !(this.$refs.tableContainer as HTMLElement).contains(
          event.target as HTMLElement
        )
      ) {
        this.showTable = false;
      }
    },
    handleScroll() {
      this.showTable = false;
      this.isexplore = false;
      this.ppoverValue = false;
      this.ppoverValue2 = false;
    },
    subtypesCheckbox(value: boolean) {
      this.cellStrictly = !value;
    },
    filterNode(value: boolean, data: any) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    checkChange() {
      const checkedNodes = (this.$refs.tree as any).getCheckedNodes();
      this.params.cellType = Array.from(
        new Set(checkedNodes.map((e: any) => e.label))
      );
      this.explore = this.params.cellType;
      this.$forceUpdate();
    },
    checkChange2() {
      const checkedNodes = (this.$refs.tree2 as any).getCheckedNodes();
      this.params.diseases = Array.from(
        new Set(checkedNodes.map((e: any) => e.label))
      );
      console.log(this.params.diseases);
      this.explore = this.params.diseases;
      this.$forceUpdate();
    },
    checkChange3() {
      const avgVal = this.avgValue.map((e: any) => e / this.avgValFormat);
      const logVal = this.logValue.map((e: any) => e / this.logValFormat);
      this.params.pValAdj = Array.from(avgVal);
      this.params.avgLog2Fc = Array.from(logVal);
      //this.explore = this.params.pValAdj;
      this.isFuzzy = false;
      this.searchData("pvalAdj", "pvalAdj");
      this.$forceUpdate();
    },
    checkChange4() {
      this.isavg = !this.isavg;
      if(this.isavg){
        this.checkChange3();
      }
    },
    
    showDropdown(index: number) {
      this.menuData[index].isActive = !this.menuData[index].isActive;
    },
    menuActive() {
      if (
        this.tableMap.singleCellRNASeq == 0 &&
        this.tableMap.rnaseq == 0 &&
        this.tableType != "single-cell RNA-seq" &&
        this.tableType != "RNA-seq"
      ) {
        this.menuData[0].isActive = false;
      } else {
        this.menuData[0].isActive = true;
      }

      if (
        this.tableMap.singleCellATACSeq == 0 &&
        this.tableMap.atacseq == 0 &&
        this.tableType != "single-cell ATAC-seq" &&
        this.tableType != "ATAC-seq"
      ) {
        this.menuData[1].isActive = false;
      } else {
        this.menuData[1].isActive = true;
      }

      if (
        this.tableMap.singleCellTCRSeq == 0 &&
        this.tableMap.tcrseq == 0 &&
        this.tableType != "single-cell TCR-seq" &&
        this.tableType != "TCR-seq"
      ) {
        this.menuData[2].isActive = false;
      } else {
        this.menuData[2].isActive = true;
      }

      if (
        this.tableMap.singleCellWGS == 0 &&
        this.tableType != "singleCellWGS"
      ) {
        this.menuData[3].isActive = false;
      } else {
        this.menuData[3].isActive = true;
      }

      if (
        this.tableMap.spatialTranscriptomics === 0 &&
        this.tableType != "spatial transcriptomics"
      ) {
        this.menuData[4].isActive = false;
      } else {
        this.menuData[4].isActive = true;
      }
      if (this.tableMap.citeseq == 0 && this.tableType != "CITE-seq") {
        this.menuData[5].isActive = false;
      } else {
        this.menuData[5].isActive = true;
      }
    },
    getDataList0() {
      if(!this.isavg){
        this.isFuzzy = true;
      }

      this.getDataList().then(this.getDataList2);
    },
    //获取列表数据
    async getDataList() {
      console.log("keyword1:" + this.keyword);
      var dfd = $.Deferred();
      this.loadingTable = true;
      setTimeout(() => {
        let postData: any = {
          index: this.pageIndex,
          size: this.pageSize,
          tableType: this.tableType ? this.tableType : null,
          value: this.keyword,
          type: this.type,
          isasc: this.isasc,
          ipAddress: localStorage.getItem("ip")
            ? localStorage.getItem("ip")
            : null,
          visitTable: this.visitTable,
        };
        if (this.explore.length > 0) {
          console.log(postData);
          postData.value = this.explore.join("-");
          postData[this.keyValue] = this.explore;
          this.IsSeachMark = true;
        }
        if (this.isFuzzy) {
            console.log("del ready"+postData['pvalAdj']);
              if(this.type === 'pvalAdj' || this.type === 'avgLog2Fc'){
                postData.type = 'id';
              }
              delete postData['pvalAdj'];
              delete postData['avgLog2Fc'];
              console.log("del success!"+postData);
          }else {
            this.keyValue = "avgLog2Fc";
            postData['avgLog2Fc'] = this.params.avgLog2Fc;
            postData['pvalAdj'] = this.params.pvalAdj;
          }
        Object.assign(postData, this.filterField);
        post(API.domainUrl + API.getTableType, postData).then(
          (response: any) => {
            if (response.status.code == 200) {
              this.tableMap = response.data.tableMap[0] || {};
              this.tableType = response.data.tableType;
              postData.tableType = response.data.tableType;
              for (let i = 0; i < this.menuData.length; i++) {
                for (let j = 0; j < this.menuData[i].childrens.length; j++) {
                  if (
                    response.data.tableType ===
                    this.menuData[i].childrens[j].name
                  ) {
                    let data: any = this.menuData[i].childrens[j].tableData;
                    // console.log("data", data);
                    this.tableThData = data;
                    let data2: any = this.menuData[i].childrens[j].data;
                    this.infoData = data2;
                  }
                }
              }
              this.loadingTable = false;
            }
            dfd.resolve();
          }
        );
      }, 500);
      return dfd.promise;
    },
    async getDataList2() {
      this.loading = true;
      var dfd = $.Deferred();
      setTimeout(() => {
        let postData: any = {
          index: this.pageIndex,
          size: this.isavg ? this.avgLimited : this.pageSize,
          tableType: this.tableType ? this.tableType : null,
          value: this.keyword,
          type: this.type,
          isasc: this.isasc,
          visitTable: this.visitTable,
        };
        if (this.explore.length > 0) {
          if (!this.params.pValAdj) {
            postData.value = this.explore.join("-");
          } else {
            this.keyValue = "pvalAdj";
            //postData["limit"] = this.avgValFormat;
            postData['avgLog2Fc'] = this.params.avgLog2Fc;
          }
          postData[this.keyValue] = this.explore;
          this.IsSeachMark = true;
        }
        if(!this.isFuzzy){
          postData['isFuzzy'] = false;
        }else{
          postData['isFuzzy'] = true;
        }
        Object.assign(postData, this.filterField);
        post(API.domainUrl + API.getData, postData).then((response: any) => {
          if (response.status.code == 200) {
            this.loading = false;
            //console.log("response.data.records", response.data.records);
            this.tableData = response.data.records || [];
            //console.log("this.tableData", this.tableData);
            this.total = response.data.total;

            //循环处理filter下拉数据
            if (response.data.metadataFilterVo) {
              for (let key in response.data.metadataFilterVo) {
                const valueArr: any[] = [];
                for (
                  let i = 0;
                  response.data.metadataFilterVo[key] &&
                  i < response.data.metadataFilterVo[key].length;
                  i++
                ) {
                  valueArr.push({
                    text: response.data.metadataFilterVo[key][i],
                    value: response.data.metadataFilterVo[key][i],
                  });
                }
                response.data.metadataFilterVo[key] = valueArr;
              }
            }
            this.metadataFilterVo = response.data.metadataFilterVo;
          } else {
            this.loading = false;
            this.$message.error(response.status.msg);
          }
          this.menuActive();
          dfd.resolve();
          if (this.isavg) {
            const Echart2Ref = this.$refs.echart2Ref as any;
            Echart2Ref.initEchart();
          }
        });
      }, 500);
      return dfd.promise;
    },
    getIPs(callback: (ip: string) => void): void {
      const ipDups: { [ip: string]: boolean } = {};
      const RTCPeerConnection = (window as any).RTCPeerConnection || (window as any).mozRTCPeerConnection || (window as any).webkitRTCPeerConnection;
      const useWebKit = !!((window as any).webkitRTCPeerConnection);
      const mediaConstraints = { optional: [{ RtpDataChannels: true }] };

      const servers = {
        iceServers: [
          { urls: 'stun:stun.services.mozilla.com' },
          { urls: 'stun:stun.l.google.com:19302' },
        ],
      };

      const pc = new RTCPeerConnection(servers, mediaConstraints);

      function handleCandidate(candidate: string): void {
        const ipRegex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/;
        const hasIp = ipRegex.exec(candidate);

        if (hasIp) {
          const ipAddr = ipRegex.exec(candidate)![1];
          if (ipDups[ipAddr] === undefined) callback(ipAddr);
          ipDups[ipAddr] = true;
        }
      }

      pc.onicecandidate = function (ice: { candidate: { candidate: string } }): void {
        if (ice.candidate) {
          handleCandidate(ice.candidate.candidate);
        }
      };

      pc.createDataChannel('');

      pc.createOffer(
        function (result: { sdp: string }) {
          pc.setLocalDescription(result, function () {}, function () {});
        },
        function () {}
      );

      setTimeout(function () {
        const lines = pc.localDescription.sdp.split('\n');
        lines.forEach(function (line: string) {
          if (line.indexOf('a=candidate:') === 0) handleCandidate(line);
        });
      }, 1000);
    },

            
    //点击提示进行搜索
    clickEg(value: string) {
      this.keyword = value;
      this.isFuzzy = false;
      this.getDataList().then(this.getDataList2);
    },
    //下载数据
    downloadFile() {
      let loadingInstance = Loading.service({});
      fetch(API.domainUrl + API.downloadCsv + "?table=" + this.tableType).then(
        (response: any) => {
          if (response.status.code == 200) {
            loadingInstance.close();
            this.$message.success(response.status.msg);
            location.href = response.data;
          } else {
            loadingInstance.close();
            this.$message.error(response.status.msg);
          }
        }
      );
    },
    //点击分页
    handleCurrentChange(val: number) {
      this.pageIndex = val;
      this.getDataList().then(this.getDataList2);
    },
    handleSizeChange(val: number) {
      this.pageIndex = 1;
      this.pageSize = val;
      this.getDataList().then(this.getDataList2);
    },
    sortChange(data: any) {
      if (data.prop == "avgLog2Fc") {
        this.type = "avg_log2_fc";
      } else if (data.prop == "pvalAdj") {
        this.type = "p_val_adj";
      } else if (data.prop == "pval") {
        this.type = "p_val";
      } else {
        this.type = data.prop;
      }
      this.isasc = data.order == "ascending" ? true : false;
      this.pageIndex = 1;
      this.pageSize = 10;
      if(!this.isavg){
        this.isFuzzy = true;
      }
      this.getDataList().then(this.getDataList2);
    },
    filterHandler(value: any, row: any, column: any) {
      const property = column["property"];
      return row[property] === value;
    },
    filterChange(data: any) {
      console.log(data);
      this.filterField = data;
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getDataList().then(this.getDataList2);
    },
    selectSymbol(symbol: any) {
      this.showTable = false;
      this.keyword = symbol.Symbol;
      this.isFuzzy = false;
      this.getDataList().then(this.getDataList2);
    },
    visitTableFun() {
      fetch(
        "https://clinicaltables.nlm.nih.gov/api/ncbi_genes/v3/search?authenticity_token=&terms=" +
          this.keyword
      ).then((response: any) => {
        let tableData = response[3];
        this.gene = response[3];
        let tableData1: any[] = [];
        if (tableData != null && tableData.length > 0)
          for (let i = 0; i < tableData.length; i++) {
            let tableData2 = tableData[i];
            let addTab3obj = {} as any;
            for (let j = 0; j < tableData2.length; j++) {
              let prop = this.tableColumns[j].prop;
              addTab3obj[prop] = tableData2[j];
            }
            tableData1.push(addTab3obj);
          }
        this.showTable = !this.showTable;
        //[{},{},{}]
        this.geneData = tableData1;
      });
    },
    isHaData(value: string) {
      if (this.visitTable) {
        if (this.tableMap[value] != 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return false;
      }
    },
    tabMenuChange(value: string, name: string, tableData: any, data: any) {
      if (!this.isHaData(value)) {
        this.infoData = data;
        this.isasc = true;
        this.tableThData = tableData;
        // let el: any = this.$refs.filterTable;
        // el.clearFilter();
        this.isShowTable = false;
        setTimeout(() => {
          this.isShowTable = true;
        }, 200);
        if (name == "WGS") {
          this.tableType = "singleCellWGS";
        } else {
          this.tableType = name;
        }
        this.pageIndex = 1;
        this.pageSize = 10;
        this.getDataList().then(this.getDataList2);
      }
    },
  },
});
